<template>
  <server-list
    :key="tableRenderKey"
    :request-func="docTypeClassList"
    search-placeholder="Пошук за назвою або кодом класу...">
    <template #action-button>
      <v-btn @click="openCreateDialog">
        <v-icon class="mr-1">mdi-plus</v-icon>
        Створити клас
      </v-btn>
    </template>

    <template #items="{ items }">
      <v-row>
        <v-col
          v-for="item in items as DocumentClassType[]"
          :key="item.id"
          cols="12"
          md="4">
          <v-hover>
            <template #default="{ isHovering, props }">
              <v-card
                :elevation="isHovering ? 2 : 0"
                border
                class="rounded-lg"
                v-bind="props"
                variant="flat">
                <v-card-text class="pa-4">
                  <div class="d-flex justify-space-between align-start mb-2">
                    <v-avatar color="#eef6fb" rounded="lg">
                      <v-icon color="#4a90e2">mdi-alpha-w-box-outline</v-icon>
                    </v-avatar>

                    <v-chip
                      :color="item.isActive ? 'success' : 'error'"
                      class="font-weight-bold"
                      variant="tonal">
                      <span class="font-weight-bold">{{
                        item.isActive ? 'Активна' : 'Неактивна'
                      }}</span>
                    </v-chip>
                  </div>

                  <div class="mb-3">
                    <div class="text-h6 font-weight-bold mb-1">
                      {{ item.name }}
                    </div>
                    <div class="text-body-2 text-grey-darken-1">
                      {{ item.description || 'Опис до підрозділу відсутній' }}
                    </div>
                  </div>

                  <v-divider class="mb-5"></v-divider>

                  <div class="d-flex justify-space-between align-center">
                    <span
                      class="text-body-2 font-weight-bold"
                      style="color: #3b66a6"
                      >{{ item.definitions.length || 0 }} типів
                    </span>

                    <div class="d-flex gap-2">
                      <v-btn
                        class="text-none me-2"
                        style="border-color: #ddd"
                        variant="outlined"
                        @click="openUpdateDialog(item)">
                        <span class="font-weight-medium">Налаштувати</span>
                      </v-btn>
                      <v-btn
                        :loading="
                          $loading.isLoading([
                            'docTypeClassActivate',
                            'docTypeClassDeactivate',
                          ])
                        "
                        border
                        class="text-none"
                        style="border-color: #ddd"
                        variant="outlined"
                        @click="toggleActive(item)">
                        <span
                          :class="item.isActive ? 'text-error' : 'text-success'"
                          class="font-weight-medium">
                          {{ item.isActive ? 'Деактивувати' : 'Активувати' }}
                        </span>
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </template>
  </server-list>
</template>
<script lang="ts">
import { openDialog } from '@/dialog'
import ServerList from '@/components/ServerList.vue'
import {
  docTypeClassActivate,
  docTypeClassDeactivate,
  docTypeClassList,
} from '@/requests/documentType'
import { ref } from 'vue'
import { DocumentClassType } from '@/utils/types/documentClassType'

export default {
  name: 'DocTypeClassList',
  components: { ServerList },
  methods: { docTypeClassList },
  setup() {
    const tableRenderKey = ref(1)

    const openCreateDialog = () => {
      openDialog({
        name: 'DocTypeClass',
        action: 'create',
        params: {
          title: 'Створити клас документа',
          submitLabel: 'Створити',
          cb: () => (tableRenderKey.value += 1),
        },
      })
    }

    const openUpdateDialog = (item: DocumentClassType) => {
      openDialog({
        name: 'DocTypeClass',
        action: 'update',
        params: {
          title: 'Редагувати клас документа',
          submitLabel: 'Зберегти',
          cb: () => {
            tableRenderKey.value += 1
          },
        },
        dialogData: { itemData: item },
      })
    }

    const toggleActive = (item: DocumentClassType) => {
      const url = item.isActive ? docTypeClassDeactivate : docTypeClassActivate
      return url(item.id).then(() => {
        tableRenderKey.value += 1
      })
    }

    return { openCreateDialog, openUpdateDialog, toggleActive, tableRenderKey }
  },
}
</script>
